import { render, staticRenderFns } from "./Login copy.vue?vue&type=template&id=0321b1dc&scoped=true"
import script from "./Login copy.vue?vue&type=script&lang=js"
export * from "./Login copy.vue?vue&type=script&lang=js"
import style0 from "./Login copy.vue?vue&type=style&index=0&id=0321b1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321b1dc",
  null
  
)

export default component.exports